import React, { useState } from 'react';
import HrnbContainer, { HrnbRow, HrnbCol } from '../components/controls/HrnbContainer';
import HrnbCard from '../components/controls/HrnbCard';
import HrnbAlert from '../components/controls/HrnbAlert';
import HrnbForm from '../components/controls/HrnbForm';
import HrnbFormControl from '../components/controls/HrnbFormControl';
import HrnbInput from '../components/controls/HrnbInput';
import HrnbTextArea from '../components/controls/HrnbTextArea';
import HrnbButton from '../components/controls/HrnbButton';
import { SendIcon } from '../icons';
import ContactCard from '../components/contacts/ContactCard';
import '../css/pages/ContactsPage.css';

/**
 * Страница контактов
 */
export default function ContactsPage() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [sending, setSending] = useState(false);
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);

    // Статический список контактов администрации
    const contacts = [
        {
            id: 1,
            name: 'Администратор',
            role: 'Главный администратор',
            email: 'admin@platform.com',
            description: 'Решение технических вопросов и модерация'
        },
        {
            id: 2,
            name: 'Модератор',
            role: 'Модерация контента',
            email: 'moderator@platform.com',
            description: 'Проверка контента и разрешение споров'
        },
        {
            id: 3,
            name: 'Поддержка',
            role: 'Техническая поддержка',
            email: 'support@platform.com',
            description: 'Помощь пользователям'
        }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSending(true);
        setError(null);
        setSuccess(null);

        try {
            // В будущем: интеграция с API отправки сообщений
            await new Promise(resolve => setTimeout(resolve, 1000)); // Имитация запроса
            
            setSuccess('Ваше сообщение отправлено! Мы свяжемся с вами в ближайшее время.');
            setFormData({ name: '', email: '', subject: '', message: '' });
        } catch (err) {
            setError(err.message || 'Ошибка при отправке сообщения');
        } finally {
            setSending(false);
        }
    };

    return (
        <HrnbContainer className="contacts-page">
            <HrnbRow>
                <HrnbCol xs={12}>
                    <HrnbCard title="Контакты" subtitle="Свяжитесь с нами">
                        <p className="contacts-page__intro">
                            Если у вас возникли вопросы или предложения, пожалуйста, свяжитесь с нами.
                        </p>
                    </HrnbCard>
                </HrnbCol>
            </HrnbRow>

            <HrnbRow>
                <HrnbCol xs={12} md={6}>
                    <HrnbCard title="Контакты администрации">
                        <div className="contacts-page__contacts-list">
                            {contacts.map((contact) => (
                                <ContactCard key={contact.id} contact={contact} />
                            ))}
                        </div>
                    </HrnbCard>
                </HrnbCol>

                <HrnbCol xs={12} md={6}>
                    <HrnbCard title="Обратная связь">
                        {success && (
                            <HrnbAlert variant="success" onClose={() => setSuccess(null)}>
                                {success}
                            </HrnbAlert>
                        )}

                        {error && (
                            <HrnbAlert variant="danger" onClose={() => setError(null)}>
                                {error}
                            </HrnbAlert>
                        )}

                        <HrnbForm onSubmit={handleSubmit}>
                            <HrnbFormControl>
                                <HrnbInput
                                    type="text"
                                    name="name"
                                    placeholder="Ваше имя"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </HrnbFormControl>

                            <HrnbFormControl>
                                <HrnbInput
                                    type="email"
                                    name="email"
                                    placeholder="Ваш email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </HrnbFormControl>

                            <HrnbFormControl>
                                <HrnbInput
                                    type="text"
                                    name="subject"
                                    placeholder="Тема"
                                    value={formData.subject}
                                    onChange={handleChange}
                                    required
                                />
                            </HrnbFormControl>

                            <HrnbFormControl>
                                <HrnbTextArea
                                    name="message"
                                    placeholder="Ваше сообщение"
                                    value={formData.message}
                                    onChange={handleChange}
                                    rows={5}
                                    required
                                />
                            </HrnbFormControl>

                            <HrnbFormControl>
                                <HrnbButton 
                                    type="submit" 
                                    disabled={sending}
                                    className="contacts-page__submit-btn"
                                    icon={<SendIcon />}
                                >
                                    {sending ? 'Отправка...' : 'Отправить'}
                                </HrnbButton>
                            </HrnbFormControl>
                        </HrnbForm>
                    </HrnbCard>
                </HrnbCol>
            </HrnbRow>
        </HrnbContainer>
    );
}
